import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import * as Group from 'groups/components/form';

const GroupsFormView = ({
  t,
  group,
  customs,
  company,
  handleSubmit,
  handleValueChange,
  handleCustomCheck,
  handleValidation,
  subcompany,
  isFetching,
  isSubmitted,
  isSaving,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("groups.title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('groups.title') +
          ' > ' +
          t(group.id ? 'Editar Grupo' : 'Agregar Grupo')
        }
        icon={'archive'}
      >
        <Group.Form
          company={company}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          handleCustomCheck={handleCustomCheck}
          isSaving={isSaving}
          isSubmitted={isSubmitted}
          subcompany={subcompany}
          values={group}
          customs={customs}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(GroupsFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/GroupFormView.js